import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  DxTextBoxModule,
  DxFormModule,
  DxScrollViewModule,
  DxDataGridModule,
  DxSelectBoxModule,
  DxButtonModule,
  DxNumberBoxModule
} from 'devextreme-angular';

import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { AdminLayoutComponent } from './admin/admin-layout/admin-layout.component';
import { UsersListComponent } from './admin/users-list/users-list.component';
import { UserEditComponent } from './admin/user-edit/user-edit.component';
import { GroupsListComponent } from './admin/groups-list/groups-list.component';
import { GroupEditComponent } from './admin/group-edit/group-edit.component';
import { LocationsListComponent } from './admin/locations-list/locations-list.component';
import { LocationEditComponent } from './admin/location-edit/location-edit.component';
import { NoAccessComponent } from './admin/no-access/no-access.component';
import { AuthService } from './auth.service';
import { CookieService } from './cookie.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginFormComponent,
    AdminLayoutComponent,
    UsersListComponent,
    UserEditComponent,
    GroupsListComponent,
    GroupEditComponent,
    LocationsListComponent,
    LocationEditComponent,
    NoAccessComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DxTextBoxModule,
    DxFormModule,
    DxScrollViewModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxButtonModule,
    DxNumberBoxModule,
    HttpClientModule
  ],
  providers: [AuthService,
    CookieService
  ],
  bootstrap: [AppComponent
  ]
})
export class AppModule { }
